import { QueryNavLink } from 'shared/lib/react-router-dom';
import styled, { css } from 'styled-components';

export const Container = styled.div<{ $fullSize: boolean; $grow: boolean }>`
  display: flex;
  flex-direction: column;

  border: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: ${({ theme }) => theme.spacing(3)};
  box-shadow: ${({ theme }) => theme.shadowBox.contentBlock};

  ${({ $fullSize }) =>
    $fullSize &&
    css`
      min-height: 0;
      flex: 1;
    `};

  ${({ $grow }) =>
    $grow &&
    css`
      flex-grow: 1;
    `};
`;

export const Header = styled.div<{ $hideBorder: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: ${({ theme }) => `0 ${theme.spacing(4)}`};
  height: 4.8rem;

  border-bottom: ${({ theme, $hideBorder }) =>
    $hideBorder ? 'none' : ` 1px solid ${theme.palette.divider}`};
`;

export const TitleContainer = styled(QueryNavLink)`
  display: flex;
  align-items: center;

  text-decoration: none;
  color: inherit;
`;

export const ChevronContainer = styled.span`
  transform: rotate(180deg);

  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[500]};
`;

export const Body = styled.div<{ $hasTitle: boolean; $noPadding: boolean }>`
  flex: 1;
  padding: ${({ theme, $hasTitle, $noPadding }) =>
    $noPadding
      ? 0
      : $hasTitle
        ? `${theme.spacing(2)} ${theme.spacing(5)} ${theme.spacing(5)}`
        : theme.spacing(5)};

  min-height: 0;
`;
